import { Grid } from "@material-ui/core";
import {
  ExpandMore,
} from '@material-ui/icons';
import { useState } from "react";
import { useDispatch } from "react-redux";
import FollowUpListManagerPage from "../../follow-up/FollowUpListManagerPage/FollowUpListManagerPage";
import { changeToConsultMode } from '../../../../../features/follow-up/followUpSlice';

export default function GestaoAVistaEtapaList({ processos = [] }) {
  const dispatch = useDispatch();

  const [openFollowUpId, setOpenFollowUpId] = useState(null);

  const openFollowUp = (id) => {
    dispatch(changeToConsultMode());
    setOpenFollowUpId(prev => prev ? null : id)
  }

  return (
    <Grid>
      {processos.map((p) => (
        <>
          <button
            type="button"
            onClick={() => openFollowUp(p.id)}
            style={{ cursor: "pointer", display: "flex", gap: 24, alignItems: "center", background: "none", border: "none" }}
          >
            <h1>{p.numero}</h1>
            <ExpandMore fontSize="large" htmlColor="black" />
          </button>

          {openFollowUpId === p.id ? <FollowUpListManagerPage id={String(p.id)} noLayout somenteEtapas somenteUsuarioLogado /> : null}
        </>
      ))}
    </Grid>
  )
}
